export enum SitemapLoaders {
  GetAll = 'GetAll'
}
